module.exports = __webpack_public_path__ + "img/completed-task.23b783df.svg";